import _ from 'underscore';

const ACTION_OPERATOR_TEXT = {
  EqualsTo: _TL_('"Action Equals to {{value}}"'),
  BeginsWith: _TL_('"Action Begins with {{value}}"'),
  Contains: _TL_('"Action Contains {{value}}"'),
  RegularExpression: _TL_('"Action Regular expression {{value}}"'),
};

const CATEGORY_OPERATOR_TEXT = {
  EqualsTo: _TL_('"Category Equals to {{value}}"'),
  BeginsWith: _TL_('"Category Begins with {{value}}"'),
  Contains: _TL_('"Category Contains {{value}}"'),
  RegularExpression: _TL_('"Category Regular expression {{value}}"'),
};

const LABEL_OPERATOR_TEXT = {
  EqualsTo: _TL_('"Label Equals to {{value}}"'),
  BeginsWith: _TL_('"Label Begins with {{value}}"'),
  Contains: _TL_('"Label Contains {{value}}"'),
  RegularExpression: _TL_('"Label Regular expression {{value}}"'),
};

const VALUE_OPERATOR_TEXT = {
  EqualsTo: _TL_('"Value Equals to {{value}}"'),
  LessThan: _TL_('"Value Less than {{value}}"'),
  GreaterThan: _TL_('"Value Greater than {{value}}"'),
};

export const getInvalidEventStrings = ({ i18n, fix = {} }) => {
  const {
    CurrentEventCategory,
    CurrentEventCategoryOperator,
    CurrentEventAction,
    CurrentEventActionOperator,
    CurrentEventLabel,
    CurrentEventLabelOperator,
    CurrentEventValue,
    CurrentEventValueOperator,
    SuggestedEventCategory,
    SuggestedEventCategoryOperator,
    SuggestedEventAction,
    SuggestedEventActionOperator,
    SuggestedEventLabel,
    SuggestedEventLabelOperator,
    SuggestedEventValue,
    SuggestedEventValueOperator,
  } = fix;

  const currentArray = [];
  const suggestedArray = [];
  if (!_.isEmpty(CurrentEventActionOperator) && !_.isEmpty(CurrentEventAction)) {
    currentArray.push(i18n.getString(ACTION_OPERATOR_TEXT[CurrentEventActionOperator] || _TL_(''), { value: CurrentEventAction }));
  }
  if (!_.isEmpty(SuggestedEventActionOperator) && !_.isEmpty(SuggestedEventAction)) {
    suggestedArray.push(i18n.getString(ACTION_OPERATOR_TEXT[SuggestedEventActionOperator] || _TL_(''), { value: SuggestedEventAction }));
  }

  if (!_.isEmpty(CurrentEventCategoryOperator) && !_.isEmpty(CurrentEventCategory)) {
    currentArray.push(i18n.getString(CATEGORY_OPERATOR_TEXT[CurrentEventCategoryOperator] || _TL_(''), { value: CurrentEventCategory }));
  }
  if (!_.isEmpty(SuggestedEventCategoryOperator) && !_.isEmpty(SuggestedEventCategory)) {
    suggestedArray.push(i18n.getString(CATEGORY_OPERATOR_TEXT[SuggestedEventCategoryOperator] || _TL_(''), { value: SuggestedEventCategory }));
  }

  if (!_.isEmpty(CurrentEventLabelOperator) && !_.isEmpty(CurrentEventLabel)) {
    currentArray.push(i18n.getString(LABEL_OPERATOR_TEXT[CurrentEventLabelOperator] || _TL_(''), { value: CurrentEventLabel }));
  }
  if (!_.isEmpty(SuggestedEventLabelOperator) && !_.isEmpty(SuggestedEventLabel)) {
    suggestedArray.push(i18n.getString(LABEL_OPERATOR_TEXT[SuggestedEventLabelOperator] || _TL_(''), { value: SuggestedEventLabel }));
  }

  if (!_.isEmpty(CurrentEventValueOperator) && !_.isEmpty(CurrentEventValue)) {
    currentArray.push(i18n.getString(VALUE_OPERATOR_TEXT[CurrentEventValueOperator] || _TL_(''), { value: CurrentEventValue }));
  }
  if (!_.isEmpty(SuggestedEventValueOperator) && !_.isEmpty(SuggestedEventValue)) {
    suggestedArray.push(i18n.getString(VALUE_OPERATOR_TEXT[SuggestedEventValueOperator] || _TL_(''), { value: SuggestedEventValue }));
  }


  return { current: currentArray.join(', '), suggested: suggestedArray.join(', ') };
};
